import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import VideoSectionStyled from "./style"
import videoFile from "../../../assets/ASMB - SOUND.mp4"

export default function VideoSection({ title, subtitle, description }) {
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlay = () => {
    setIsPlaying(true)
  }

  return (
    <VideoSectionStyled>
      <Container>
        <Row className="justify-content-center">
          <Col xs="12" className="text-center mb-5">
            {subtitle && (
              <VideoSectionStyled.SubTitle>
                {subtitle}
              </VideoSectionStyled.SubTitle>
            )}
            {title && (
              <VideoSectionStyled.Title>{title}</VideoSectionStyled.Title>
            )}
            {description && (
              <VideoSectionStyled.Description>
                {description}
              </VideoSectionStyled.Description>
            )}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="12" lg="10" xl="9">
            <VideoSectionStyled.VideoWrapper>
              <video
                controls
                controlsList="nodownload"
                preload="auto"
                onPlay={handlePlay}
                onLoadedData={(e) => {
                  e.currentTarget.pause()
                  e.currentTarget.currentTime = 0.1
                }}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px",
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#000",
                }}
              >
                <source src={videoFile} type="video/mp4" />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
              {!isPlaying && (
                <VideoSectionStyled.PlayButton onClick={(e) => {
                  e.currentTarget.previousSibling.play()
                  setIsPlaying(true)
                }}>
                  <VideoSectionStyled.PlayIcon>▶</VideoSectionStyled.PlayIcon>
                </VideoSectionStyled.PlayButton>
              )}
            </VideoSectionStyled.VideoWrapper>
          </Col>
        </Row>
      </Container>
    </VideoSectionStyled>
  )
}
